import { balanceFormatter } from '~/utils/helperFunctions';

const exteriorWallTypeOptions = [
  { label: "Aluminum/Vinyl", value: "aluminum_vinyl" },
  { label: "Brick", value: "brick" },
  { label: "Vinyl", value: "vinyl" },
  { label: "Frame", value: "frame" },
  { label: "Brick Veneer", value: "brick_veneer" },
  { label: "Stucco", value: "stucco" },
  { label: "Wood", value: "wood" },
  { label: "Wood Siding", value: "wood_siding" },
  { label: "Wood Siding/Shingle", value: "wood_siding_shingle" },
  { label: "Frame Siding", value: "frame_siding" },
  { label: "Masonry", value: "masonry" },
  { label: "Frame/Masonry", value: "frame_masonry" },
  { label: "Concrete Block/Stucco", value: "concrete_block_stucco" },
  { label: "Brick/Wood", value: "brick_wood" },
  { label: "Frame/Stucco", value: "frame_stucco" },
  { label: "Siding Sheathing", value: "siding_sheathing" },
  { label: "Frame/Wood", value: "frame_wood" },
  { label: "Cbs/Holw Tile/Fr/Stud/Sheat/Sd", value: "cbs_holw_tile_stud" },
  { label: "Frame Concrete Block/Brick", value: "frame_concrete_block_brick" },
  { label: "Aluminum Siding", value: "aluminum_siding" },
  { label: "Concrete Block", value: "concrete_block" },
  { label: "Wood Frame", value: "wood_frame" },
  { label: "Frame/Masonry/Veneer", value: "frame_masonry_veneer" },
  { label: "Hardboard", value: "hardboard" },
  { label: "Aluminum", value: "aluminum" },
  { label: "Frame/Vinyl", value: "frame_vinyl" },
  { label: "Masonite", value: "masonite" },
  { label: "Lap Siding", value: "lap_siding" },
  { label: "Metal", value: "metal" },
  { label: "Frame Brick", value: "frame_brick" },
  { label: "Masonry Veneer", value: "masonry_veneer" },
  { label: "Brick/Stone", value: "brick_stone" },
  { label: "Masonry/Stucco", value: "masonry_stucco" },
  { label: "Composition", value: "composition" },
  { label: "Wood Sheathing", value: "wood_sheathing" },
  { label: "Shingle Siding", value: "shingle_siding" },
  { label: "Stone", value: "stone" },
  { label: "Frame/Plywood", value: "frame_plywood" },
  { label: "Asbestos", value: "asbestos" },
  { label: "Plywood", value: "plywood" },
  { label: "Block/Stucco", value: "block_stucco" },
  { label: "Concrete", value: "concrete" },
  { label: "Frame Hardboard", value: "frame_hardboard" },
  { label: "Block Painted", value: "block_painted" },
  { label: "Wood/Aluminum", value: "wood_aluminum" },
  { label: "Brick Siding", value: "brick_siding" },
  { label: "Aluminum/Brick", value: "aluminum_brick" },
  { label: "Cinder Block/Stucco", value: "cinder_block_stucco" },
  { label: "Adobe Block", value: "adobe_block" },
  { label: "Brick/Masonry", value: "brick_masonry" },
  { label: "Block", value: "block" },
  { label: "Log", value: "log" },
  { label: "Brick/Vinyl", value: "brick_vinyl" },
  { label: "Frame/Aluminum", value: "frame_aluminum" },
  { label: "Asbestos Siding", value: "asbestos_siding" },
  { label: "Frame/Wood Siding", value: "frame_wood_siding" },
  { label: "Brick/Stucco", value: "brick_stucco" },
  { label: "Hardwood", value: "hardwood" },
  { label: "Steel", value: "steel" },
  { label: "Brick Veneer/Wood", value: "brick_veneer_wood" },
  { label: "Composition Siding", value: "composition_siding" },
  { label: "Stucco/Wood Frame", value: "stucco_wood_frame" },
  { label: "Concrete/Cinder Block", value: "concrete_cinder_block" },
  { label: "Plaster", value: "plaster" },
  { label: "Asbestos Shingle", value: "asbestos_shingle" },
  { label: "Shingle", value: "shingle" },
  { label: "Frame/Metal", value: "frame_metal" },
  { label: "Wood Shake/Shingle", value: "wood_shake_shingle" },
  { label: "Hardboard/Plywood", value: "hardboard_plywood" },
  { label: "Brick/Concrete", value: "brick_concrete" },
  { label: "Masonry/Wood", value: "masonry_wood" },
  { label: "Stone Veneer", value: "stone_veneer" },
  { label: "Frame/Block", value: "frame_block" },
  { label: "Metal Siding", value: "metal_siding" },
  { label: "Board & Batten", value: "board_batten" },
  { label: "Slump", value: "slump" },
  { label: "Cinder Block", value: "cinder_block" },
  { label: "Vinyl/Wood", value: "vinyl_wood" },
  { label: "Clapboard", value: "clapboard" },
  { label: "Wood Frame/Vinyl", value: "wood_frame_vinyl" },
  { label: "Stucco/Masonry", value: "stucco_masonry" },
  { label: "Wood Frame/Asbestos", value: "wood_frame_asbestos" },
  { label: "Stone/Stucco", value: "stone_stucco" },
  { label: "Frame Wood/Stucco", value: "frame_wood_stucco" },
  { label: "Wood Frame/Siding", value: "wood_frame_siding" },
  { label: "Sheathing/Wood", value: "sheathing_wood" },
  { label: "Stucco/Wood", value: "stucco_wood" },
  { label: "Asphalt Siding", value: "asphalt_siding" },
  { label: "Brick/Frame/Wood", value: "brick_frame_wood" },
  { label: "Mixture", value: "mixture" },
  { label: "Frame/Shingle Siding", value: "frame_shingle_siding" },
  { label: "Weatherboard", value: "weatherboard" },
  { label: "Stucco/Tile/Wood", value: "stucco_tile_wood" },
  { label: "Prefab Wood Panel", value: "prefab_wood_panel" },
  { label: "Wallboard", value: "wallboard" },
  { label: "Stone/Wood", value: "stone_wood" },
  { label: "Stone/Siding", value: "stone_siding" },
  { label: "Rock/Stone", value: "rock_stone" },
  { label: "Masonite/Sheathing", value: "masonite_sheathing" },
  { label: "Frame/Wood Shingle", value: "frame_wood_shingle" },
  { label: "Wood Frame(Stucco Or Asbestos)", value: "wood_frame_stucco_asbestos" },
  { label: "Composition Shingle", value: "composition_shingle" },
  { label: "Concrete/Dryvit", value: "concrete_dryvit" },
  { label: "Brick/Wood/Vinyl", value: "brick_wood_vinyl" },
  { label: "Single", value: "single" },
  { label: "Aluminum/Metal", value: "aluminum_metal" },
  { label: "Fiberglass", value: "fiberglass" },
  { label: "Concrete Block/Masonry", value: "concrete_block_masonry" },
  { label: "Masonite/Vinyl", value: "masonite_vinyl" },
  { label: "Frame/Aluminum/Vinyl", value: "frame_aluminum_vinyl" },
  { label: "Stone/Wood Frame", value: "stone_wood_frame" },
  { label: "Fiberboard", value: "fiberboard" },
  { label: "Stone/Vinyl", value: "stone_vinyl" },
  { label: "Tile", value: "tile" },
  { label: "Brick Frame/Stone", value: "brick_frame_stone" },
  { label: "Metal/Steel", value: "metal_steel" },
  { label: "Panel", value: "panel" },
  { label: "Masonite/Wood", value: "masonite_wood" },
  { label: "Brick/Wood/Stone Veneer", value: "brick_wood_stone_veneer" },
  { label: "Custom", value: "custom" },
  { label: "Frame/Shingle", value: "frame_shingle" },
  { label: "Log/Wood Shingle", value: "log_wood_shingle" },
  { label: "Board & Batten/Wood Frame", value: "board_batten_wood_frame" },
  { label: "Prefab Panel", value: "prefab_panel" },
  { label: "Corrugated Metal/Wallboard", value: "corrugated_metal_wallboard" },
  { label: "Brick/Metal", value: "brick_metal" },
  { label: "Frame Composition", value: "frame_composition" },
  { label: "Tongue & Groove/Channel", value: "tongue_groove_channel" },
  { label: "Brick/Frame/Veneer", value: "brick_frame_veneer" },
  { label: "Metal/Wood", value: "metal_wood" },
  { label: "Composition Siding/Stucco", value: "composition_siding_stucco" },
  { label: "Concrete Masonry", value: "concrete_masonry" },
  { label: "Shingle/Wood", value: "shingle_wood" },
  { label: "Precast Concrete", value: "precast_concrete" },
  { label: "Frame/Stone", value: "frame_stone" },
  { label: "Slate", value: "slate" },
  { label: "Masonry/Stone", value: "masonry_stone" },
  { label: "Precast Concrete Panel", value: "precast_concrete_panel" },
  { label: "Brick/Concrete Block Stucco", value: "brick_concrete_block_stucco" },
  { label: "Synthetic Panel/Siding", value: "synthetic_panel_siding" },
  { label: "Brick/Wood Siding", value: "brick_wood_siding" },
  { label: "Permastone", value: "permastone" },
  { label: "Pressboard", value: "pressboard" },
  { label: "Brick/Stone Veneer", value: "brick_stone_veneer" },
  { label: "Asbestos Frame", value: "asbestos_frame" },
  { label: "Block/Brick", value: "block_brick" },
  { label: "Asbestos/Block/Plywood", value: "asbestos_block_plywood" },
  { label: "Tilt-Up", value: "tilt_up" },
  { label: "Concrete Stucco", value: "concrete_stucco" },
  { label: "Sheathing", value: "sheathing" },
  { label: "Glass", value: "glass" },
  { label: "Black-Board", value: "black_board" },
  { label: "Prefab Wood", value: "prefab_wood" },
  { label: "Aluminum/Stone", value: "aluminum_stone" },
  { label: "Asbestos/Masonite", value: "asbestos_masonite" },
  { label: "Prefab Metal", value: "prefab_metal" },
  { label: "Brick/Frame/Stucco", value: "brick_frame_stucco" },
  { label: "Insulated Finish/Eifs", value: "insulated_finish_eifs" },
  { label: "Brick Veneer/Stone/Wood", value: "brick_veneer_stone_wood" },
  { label: "Stucco/Vinyl", value: "stucco_vinyl" },
  { label: "Metal Panel", value: "metal_panel" },
  { label: "Precast Textured Panel", value: "precast_textured_panel" },
  { label: "Cinder Block/Wood", value: "cinder_block_wood" },
  { label: "Tilt-Up/Concrete", value: "tilt_up_concrete" },
  { label: "Frame/Stone/Veneer", value: "frame_stone_veneer" },
  { label: "Stucco/Tile", value: "stucco_tile" },
  { label: "Block/Masonry", value: "block_masonry" },
  { label: "Frame/Stucco Shingle", value: "frame_stucco_shingle" },
  { label: "Asbestos/Brick Veneer/Wood", value: "asbestos_brick_veneer_wood" },
  { label: "Shingle Siding/Wood Frame", value: "shingle_siding_wood_frame" },
  { label: "Brick/Stucco/Wood", value: "brick_stucco_wood" },
  { label: "Steel Frame", value: "steel_frame" },
  { label: "Plywood/Wood Frame", value: "plywood_wood_frame" },
  { label: "Frame Aluminum/Brick", value: "frame_aluminum_brick" },
  { label: "Asphalt/Fiberglass/Wood Frame", value: "asphalt_fiberglass_wood_frame" },
  { label: "Concrete Brick/Panel", value: "concrete_brick_panel" },
  { label: "Shingle/Brick", value: "shingle_brick" },
  { label: "Glass/Masonry", value: "glass_masonry" },
  { label: "Brick/Masonite", value: "brick_masonite" },
  { label: "Cb/Metal/Glass Panel", value: "cb_metal_glass_panel" },
  { label: "Concrete Brick/Composition", value: "concrete_brick_composition" },
  { label: "Aluminum/Masonite", value: "aluminum_masonite" },
  { label: "Gunite/Spraycrete", value: "gunite_spraycrete" },
  { label: "Waferboard", value: "waferboard" },
  { label: "Brick/Tile", value: "brick_tile" },
  { label: "Glass/Metal", value: "glass_metal" },
  { label: "Brick/Shingle", value: "brick_shingle" },
  { label: "Aluminum/Block", value: "aluminum_block" },
  { label: "Brick/Concrete Block/Wood", value: "brick_concrete_block_wood" },
  { label: "Asbestos/Wood", value: "asbestos_wood" },
  { label: "Aluminum/Stucco", value: "aluminum_stucco" },
  { label: "Steel/Stucco", value: "steel_stucco" },
  { label: "Simulated Brick, Rock, Stone", value: "simulated_brick,_rock,_stone" },
  { label: "Window Wall", value: "window_wall" },
  { label: "Frame Wood/Brick", value: "frame_wood_brick" },
  { label: "Frame/Permastone", value: "frame_permastone" },
  { label: "Frame Shingle/Brick", value: "frame_shingle_brick" },
  { label: "Masonite/Stone", value: "masonite_stone" },
  { label: "Steel/Wood", value: "steel_wood" },
  { label: "Styrofoam Stucco", value: "styrofoam_stucco" },
  { label: "Fireproof/Fire Retardant", value: "fireproof_fire_retardant" },
  { label: "Stone/Wood Siding", value: "stone_wood_siding" },
  { label: "Frame/Stucco/Siding", value: "frame_stucco_siding" },
  { label: "Concrete Tile", value: "concrete_tile" },
  { label: "Frame/Steel Panel", value: "frame_steel_panel" },
  { label: "Block/Wood", value: "block_wood" },
  { label: "Wallboard/Wood Shingle", value: "wallboard_wood_shingle" },
  { label: "Prefab", value: "prefab" },
  { label: "Stone Veneer/Wood Frame", value: "stone_veneer_wood_frame" },
  { label: "Sheathing/Stucco", value: "sheathing_stucco" },
  { label: "Brick/Stone/Wood Siding", value: "brick_stone_wood_siding" },
  { label: "Block/Masonry/Stucco", value: "block_masonry_stucco" },
  { label: "Brick/Masonry/Stone", value: "brick_masonry_stone" },
  { label: "Steel/Panel", value: "steel_panel" },
  { label: "Metal/Stone/Veneer", value: "metal_stone_veneer" },
  { label: "Wood Veneer", value: "wood_veneer" },
  { label: "Corrugated Steel Panel", value: "corrugated_steel_panel" },
  { label: "Porcelain/Enamel Panel", value: "porcelain_enamel_panel" },
  { label: "Iron Post/Corrugated Iron", value: "iron_post_corrugated_iron" },
  { label: "Block/Stone", value: "block_stone" },
  { label: "Asbestos/Stone/Wood", value: "asbestos_stone_wood" },
  { label: "Marble/Stone", value: "marble_stone" },
  { label: "Solar Glass", value: "solar_glass" },
  { label: "Wood/Aluminum/Composition Shin", value: "wood_aluminum_composition_shin" },
  { label: "Metal/Wood Frame", value: "metal_wood_frame" },
  { label: "Tar Paper", value: "tar_paper" },
  { label: "Corrugated Panel", value: "corrugated_panel" },
  { label: "Concrete/Glass Panels", value: "concrete_glass_panels" },
  { label: "Frame/Steel/Siding", value: "frame_steel_siding" },
  { label: "Stone/Veneer/Wood", value: "stone_veneer_wood" },
  { label: "Clay Tile", value: "clay_tile" },
  { label: "Brick Veneer/Block", value: "brick_veneer_block" },
  { label: "Vitrolite", value: "vitrolite" },
  { label: "Masonry/Metal", value: "masonry_metal" },
  { label: "Asbestos/Stone", value: "asbestos_stone" },
  { label: "Frame/Steel/Metal", value: "frame_steel_metal" },
  { label: "Brick/Glass", value: "brick_glass" },
  { label: "Open End", value: "open_end" },
  { label: "Asbestos/Vinyl", value: "asbestos_vinyl" },
  { label: "Aluminum/Glass", value: "aluminum_glass" },
  { label: "Brick Veneer/Wall Board", value: "brick_veneer_wall_board" },
  { label: "Hardboard/Vinyl", value: "hardboard_vinyl" },
  { label: "Corrugated Siding", value: "corrugated_siding" },
  { label: "Marble", value: "marble" },
  { label: "Panel/Stucco", value: "panel_stucco" },
  { label: "Asbestos/Permastone", value: "asbestos_permastone" },
  { label: "Stucco/Veneer", value: "stucco_veneer" },
  { label: "Asbestos/Brick", value: "asbestos_brick" },
  { label: "Haydite", value: "haydite" },
  { label: "Asbestos/Concrete", value: "asbestos_concrete" },
  { label: "Aluminum Siding/Stucco", value: "aluminum_siding_stucco" },
  { label: "Permastone/Wood", value: "permastone_wood" },
  { label: "Concrete Block/Steel", value: "concrete_block_steel" },
  { label: "Concrete/Frame/Steel", value: "concrete_frame_steel" },
  { label: "Asbestos/Block", value: "asbestos_block" },
  { label: "Masonite/Stucco", value: "masonite_stucco" },
  { label: "Concrete Block/Metal", value: "concrete_block_metal" },
  { label: "Concrete Block/Stone Veneer", value: "concrete_block_stone_veneer" },
  { label: "Metal/Stucco", value: "metal_stucco" },
  { label: "Glass/Steel", value: "glass_steel" },
  { label: "Shingle/Stucco", value: "shingle_stucco" },
  { label: "Brick/Permastone", value: "brick_permastone" },
  { label: "Asbestos/Block/Wood", value: "asbestos_block_wood" },
  { label: "Steel Frame/Wood", value: "steel_frame_wood" },
  { label: "Concrete/Metal", value: "concrete_metal" },
  { label: "Precast Curtain Walls", value: "precast_curtain_walls" },
  { label: "Brick/Metal & Glass Panel", value: "brick_metal_glass_panel" },
  { label: "Frame/Glass", value: "frame_glass" },
  { label: "Frame-Stud/Lath/Stuc/Asb Sdg", value: "frame_stud_lath_stuc_asb_sdg" },
  { label: "Copper Siding", value: "copper_siding" },
  { label: "Gunite", value: "gunite" },
  { label: "Block/Asbestos Shingle", value: "block_asbestos_shingle" },
  { label: "Block/Metal", value: "block_metal" },
  { label: "Block/Stone/Wood", value: "block_stone_wood" },
  { label: "Board On Post", value: "board_on_post" },
  { label: "Brick/Metal/Veneer", value: "brick_metal_veneer" },
  { label: "Cinder Block/Masonite", value: "cinder_block_masonite" },
  { label: "Frame Clapboard", value: "frame_clapboard" },
  { label: "Frame/Tile/Wood", value: "frame_tile_wood" },
  { label: "Glass/Stone", value: "glass_stone" },
  { label: "Glass/Wood", value: "glass_wood" },
  { label: "Post & Board", value: "post_board" },
  { label: "Stainless Steel W/Bronzed Glas", value: "stainless_steel_bronzed_glas" },
];

const heatingTypeOptions = [
  { label: 'Baseboard', value: 'baseboard' },
  { label: 'Central', value: 'central' },
  { label: 'Coal', value: 'coal' },
  { label: 'Electric', value: 'electric' },
  { label: 'Floor/Wall', value: 'floor_wall' },
  { label: 'Forced Air', value: 'forced_air' },
  { label: 'Gravity', value: 'gravity' },
  { label: 'Heat Pump', value: 'heat_pump' },
  { label: 'Hot Water', value: 'hot_water' },
  { label: 'Natural Gas', value: 'natural_gas' },
  { label: 'Oil', value: 'oil' },
  { label: 'Radiant', value: 'radiant' },
  { label: 'Solar', value: 'solar' },
  { label: 'Space/Suspended', value: 'space_suspended' },
  { label: 'Steam', value: 'steam' },
  { label: 'Vent', value: 'vent' },
  { label: 'Wood Burning', value: 'wood_burning' },
  { label: 'Zone', value: 'zone' },
];

const educationLevelOptions = [
  { label: 'Associate\'s Degree', value: 'associates' },
  { label: 'Bachelor\'s Degree', value: 'bachelors' },
  { label: 'High School Diploma', value: 'diploma' },
  { label: 'Post Graduate Degree', value: 'post_graduate' },
  { label: 'No High School Diploma', value: 'no_diploma' },
];

const sicCodeOptions = [];

const naicsCodeOptions = [];

const estimatedSquareFootageOptions = [
  { label: '1 - 1,499', value: '1' },
  { label: '1,500 - 2,499', value: '2' },
  { label: '2,500 - 4,999', value: '3' },
  { label: '5,000 - 9,999', value: '4' },
  { label: '10,000 - 19,999', value: '5' },
  { label: '20,000 - 39,999', value: '6' },
  { label: '40,000 - 99,999', value: '7' },
  { label: '100,000+', value: '8' },
];

const estimatedFleetSizeOptions = [
  { label: '1-10', value: '1-10' },
  { label: '11-19', value: '11-19' },
  { label: '20-49', value: '20-49' },
  { label: '50-99', value: '50-99' },
  { label: '100+', value: '100+' },
];

export const consumerDataAxleFilterDefinitions = [
  { category: 'Property filters', field: 'real_estate.acres', helper: 'The size of the property in acres.', key: 'lotSize', label: 'Lot size', max: 100, min: 0, step: 0.001, suffix: 'acres', type: 'range' },
  { category: 'Property filters', field: 'real_estate.square_footage', helper: 'The size of the home in square feet.', key: 'livingArea', label: 'Square footage', max: 15000, min: 0, step: 100, type: 'range' },
  { category: 'Property filters', field: 'real_estate.estimated_home_value', helper: 'An estimate of the current home value.', key: 'homeValue', label: 'Home value', max: 5000000, min: 0, step: 25000, type: 'range', unit: 'currency' },
  { category: 'Property filters', field: 'real_estate.year_home_built', helper: 'The year the home was built.', key: 'yearBuilt', label: 'Year built', max: new Date().getFullYear(), min: 1700, step: 1, type: 'range' },
  { category: 'Property filters', field: 'real_estate.exterior_wall_type', helper: 'The type or finish of the exterior walls of the home.', key: 'exteriorWallType', label: 'Exterior wall type', options: exteriorWallTypeOptions, type: 'multi' },
  { category: 'Property filters', field: 'real_estate.fireplace, real_estate.garage, real_estate.pool', helper: 'Indicates whether the property includes specific features.', key: 'homeFeatures', label: 'Home features', options: ['Fireplace', 'Garage', 'Pool'], type: 'features' },
  { category: 'Property filters', field: 'real_estate.heating_type', helper: 'The type of system used to heat the home.', key: 'heatingType', label: 'Heating type', options: heatingTypeOptions, type: 'multi' },
  { category: 'Resident Filters', field: 'family.estimated_home_owner', helper: 'The family owns their home.', key: 'homeowner', label: 'Homeowner', options: ['Yes', 'No'], type: 'single' },
  { category: 'Resident Filters', field: 'family.estimated_appeared_on', helper: 'How long the family has lived at the location.', key: 'lengthAtLocation', label: 'Length at location', max: 50, min: 0, step: 1, suffix: 'years', type: 'range' },
  { category: 'Resident Filters', field: 'estimated_date_of_birth', helper: 'The age of the individual.', key: 'residentAge', label: 'Age', max: 120, min: 18, step: 1, suffix: 'years', type: 'range' },
  { category: 'Resident Filters', field: 'gender', helper: 'The gender of the person.', key: 'residentGender', label: 'Gender', options: [{ label: 'Female', value: 'F' }, { label: 'Male', value: 'M' }], type: 'single' },
  { category: 'Resident Filters', field: 'family.estimated_income', helper: 'The estimated income of the family.', key: 'estimatedIncome', label: 'Estimated income', max: 500000, min: 0, step: 5000, type: 'range', unit: 'currency' },
  { category: 'Resident Filters', field: 'family.estimated_education_level', helper: 'The highest education level within the family.', key: 'educationLevel', label: 'Education level', options: educationLevelOptions, type: 'multi' },
];

export const businessDataAxleFilterDefinitions = [
  { asyncLookup: true, category: 'Company filters', field: 'sic_code_ids', helper: 'The lines of business represented by Standard Industrial Classification codes.', initialLookupQuery: 'a', key: 'sicCodes', label: 'SIC code', maxRenderedOptions: 50, options: sicCodeOptions, preserveValueCase: true, type: 'multi' },
  { asyncLookup: true, category: 'Company filters', field: 'naics_code_ids', helper: 'The lines of business represented by North American Industry Classification System codes.', initialLookupQuery: 'a', key: 'naicsCodes', label: 'NAICS code', maxRenderedOptions: 50, options: naicsCodeOptions, preserveValueCase: true, type: 'multi' },
  { category: 'Company filters', field: 'estimated_location_employee_count', helper: 'Estimated number of employees who work at this location.', key: 'employeeCount', label: 'Number of employees', min: 0, step: 1, type: 'range' },
  { category: 'Company filters', field: 'estimated_location_sales_volume', helper: "An estimation of the place's sales revenue.", key: 'salesVolume', label: 'Sales volume', min: 0, step: 1000, type: 'range', unit: 'currency' },
  { category: 'Company filters', field: 'estimated_square_footage', helper: 'The square footage of the location.', key: 'businessSquareFootage', label: 'Square footage', options: estimatedSquareFootageOptions, preserveOptionOrder: true, preserveValueCase: true, type: 'multi' },
  { category: 'Company filters', field: 'estimated_fleet_size', helper: 'The number of vehicles owned or used by the location.', key: 'fleetSize', label: 'Fleet size', options: estimatedFleetSizeOptions, preserveOptionOrder: true, preserveValueCase: true, type: 'multi' },
  { category: 'Company filters', field: 'estimated_opened_for_business', helper: 'The number of years the location has been in business.', key: 'yearsInBusiness', label: 'Years in business', max: 200, min: 0, step: 1, transform: 'yearsInBusiness', type: 'range' },
];

export const dataAxleFilterDefinitions = consumerDataAxleFilterDefinitions;

export const getDataAxleFilterDefinitions = (contactType = 'consumers') => (
  contactType === 'businesses'
    ? businessDataAxleFilterDefinitions
    : consumerDataAxleFilterDefinitions
);

const buildFilterByKey = (definitions) => definitions.reduce((filters, definition) => ({
  ...filters,
  [definition.key]: definition,
}), {});

export const dataAxleFilterByKey = buildFilterByKey(consumerDataAxleFilterDefinitions);

export const getDataAxleFilterByKey = (contactType = 'consumers') =>
  buildFilterByKey(getDataAxleFilterDefinitions(contactType));

const buildFilterByLabel = (definitions) => definitions.reduce((filters, definition) => ({
  ...filters,
  [definition.label.toLowerCase()]: definition,
}), {});

export const anyFilterOption = 'Any';
export const maxVisibleMultiFilterOptions = 5;

const unknownFilterOptionValues = new Set(['n', 'o', 'x', 'y']);

const getOptionValue = (option) => (
  option && typeof option === 'object' ? option.value : option
);

const getOptionLabel = (option) => (
  option && typeof option === 'object' ? option.label : option
);

const filterOptionCache = new WeakMap();

const isKnownFilterOption = (option, definition = {}) => {
  const optionValue = String(getOptionValue(option) || '').trim();
  const optionLabel = String(getOptionLabel(option) || '').trim();
  const normalizedValue = optionValue.toLowerCase();
  const normalizedLabel = optionLabel.toLowerCase();

  if (!optionValue && !optionLabel) return false;
  if (normalizedValue.includes('unknown') || normalizedLabel.includes('unknown')) return false;
  if (!definition.preserveValueCase && /^\d+$/.test(optionValue)) return false;
  if (unknownFilterOptionValues.has(normalizedValue)) return false;
  if (unknownFilterOptionValues.has(normalizedLabel)) return false;

  return true;
};

const getCachedFilterOptionData = (definition = {}) => {
  if (!definition || typeof definition !== 'object') {
    return {
      dropdownOptions: [],
      knownOptions: [],
      optionByNormalizedLabel: new Map(),
      optionByNormalizedValue: new Map(),
      sortedOptions: [],
    };
  }

  const cachedData = filterOptionCache.get(definition);
  if (cachedData) return cachedData;

  const knownOptions = (definition.options || [])
    .filter((option) => isKnownFilterOption(option, definition));
  const sortedOptions = definition.preserveOptionOrder
    ? [...knownOptions]
    : [...knownOptions].sort((firstOption, secondOption) =>
      String(getOptionLabel(firstOption) || '').localeCompare(
        String(getOptionLabel(secondOption) || ''),
        undefined,
        { sensitivity: 'base' }
      )
    );
  const dropdownOptions = sortedOptions.map((option) => ({
    id: getOptionValue(option),
    title: getOptionLabel(option),
  }));
  const optionByNormalizedValue = new Map();
  const optionByNormalizedLabel = new Map();

  knownOptions.forEach((option) => {
    const optionValue = String(getOptionValue(option) || '').trim().toLowerCase();
    const optionLabel = String(getOptionLabel(option) || '').trim().toLowerCase();

    if (optionValue && !optionByNormalizedValue.has(optionValue)) {
      optionByNormalizedValue.set(optionValue, option);
    }
    if (optionLabel && !optionByNormalizedLabel.has(optionLabel)) {
      optionByNormalizedLabel.set(optionLabel, option);
    }
  });

  const optionData = {
    dropdownOptions,
    knownOptions,
    optionByNormalizedLabel,
    optionByNormalizedValue,
    sortedOptions,
  };

  filterOptionCache.set(definition, optionData);
  return optionData;
};

const getKnownFilterOptions = (definition) =>
  getCachedFilterOptionData(definition).knownOptions;

export const getSortedFilterOptions = (definition) =>
  getCachedFilterOptionData(definition).sortedOptions;

export const sanitizeFilterNumber = (value) => {
  if (value === '' || value === null || value === undefined) return '';

  const normalizedValue = typeof value === 'string' ? value.replace(/[$,]/g, '') : value;
  if (typeof normalizedValue === 'string' && normalizedValue.trim() === '') return '';

  const numberValue = Number(normalizedValue);
  return Number.isFinite(numberValue) ? numberValue : '';
};

export const isCurrencyFilter = (definition) => definition?.unit === 'currency';

export const formatCurrencyFilterInput = (value) => {
  const numberValue = sanitizeFilterNumber(value);

  return numberValue === '' ? '' : balanceFormatter(numberValue, 0);
};

export const parseCurrencyFilterInput = (value) => {
  const numberValue = sanitizeFilterNumber(value);

  return numberValue === '' ? '' : String(numberValue);
};

export const createEmptyFilterValue = (definition) => {
  if (definition.type === 'boolean') return { enabled: false };
  if (['features', 'multi'].includes(definition.type)) return { values: [] };
  if (definition.type === 'single') return { value: '' };
  return { max: '', min: '' };
};

export const normalizeFilterOptionValue = (definition, value) => {
  const normalizedValue = String(value || '').trim();
  if (!normalizedValue) return '';
  if (normalizedValue.toLowerCase() === anyFilterOption.toLowerCase()) return '';

  const normalizedOptionValue = normalizedValue.toLowerCase();
  const {
    optionByNormalizedLabel,
    optionByNormalizedValue,
  } = getCachedFilterOptionData(definition);
  const matchedOption =
    optionByNormalizedValue.get(normalizedOptionValue) ||
    optionByNormalizedLabel.get(normalizedOptionValue);

  if (matchedOption) return getOptionValue(matchedOption) || '';
  return definition.asyncLookup ? normalizedValue : '';
};

export const normalizeFilterMultiValues = (definition, values) => {
  const rawValues = Array.isArray(values) ? values : [];
  const hasAnyValue = rawValues.some(
    (value) => String(value || '').trim().toLowerCase() === anyFilterOption.toLowerCase()
  );

  if (hasAnyValue) return [];

  return [...new Set(rawValues
    .map((value) => normalizeFilterOptionValue(definition, value))
    .filter(Boolean))];
};

export const getFilterDropdownOptions = (definition) =>
  getCachedFilterOptionData(definition).dropdownOptions;

export const getFilterOptionLabel = (definition, value) => {
  const normalizedValue = String(value || '').trim().toLowerCase();
  const { optionByNormalizedValue } = getCachedFilterOptionData(definition);
  const matchedOption = optionByNormalizedValue.get(normalizedValue);

  return getOptionLabel(matchedOption) || value;
};

export const getFilterOptionDisplayLabel = (definition, value, optionLabelsByKey = {}) => (
  optionLabelsByKey?.[definition.key]?.[value] || getFilterOptionLabel(definition, value)
);

export const getFilterOptionsPreview = (
  definition,
  values = [],
  visibleLimit = maxVisibleMultiFilterOptions,
  optionLabelsByKey = {}
) => {
  const safeValues = Array.isArray(values) ? values : [];
  const previewValues = safeValues
    .slice(0, visibleLimit)
    .map((value) => getFilterOptionDisplayLabel(definition, value, optionLabelsByKey));

  return safeValues.length > visibleLimit
    ? `${previewValues.join(', ')}, ...`
    : previewValues.join(', ');
};

export const hasAllMultiFilterOptionsSelected = (definition, values = []) =>
  definition.type === 'multi' &&
  Array.isArray(definition.options) &&
  getKnownFilterOptions(definition).length > 0 &&
  Array.isArray(values) &&
  values.length === getKnownFilterOptions(definition).length;

export const isMultiOptionFilter = (definition) => ['features', 'multi'].includes(definition.type);

export const createEmptyFilterState = (contactType = 'consumers') =>
  getDataAxleFilterDefinitions(contactType).reduce((filters, definition) => ({
    ...filters,
    [definition.key]: createEmptyFilterValue(definition),
  }), {});

export const isRangeFilterValueInvalid = (value = {}) => {
  const min = sanitizeFilterNumber(value?.min);
  const max = sanitizeFilterNumber(value?.max);

  return min !== '' && max !== '' && min > max;
};

export const normalizeFindContactFilters = (filters, contactType = 'consumers') => {
  const filterDefinitions = getDataAxleFilterDefinitions(contactType);
  const dataAxleFilterByLabel = buildFilterByLabel(filterDefinitions);
  const normalizedFilters = createEmptyFilterState(contactType);

  if (Array.isArray(filters)) {
    filters.forEach((filter) => {
      const definition = dataAxleFilterByLabel[String(filter || '').trim().toLowerCase()];
      if (!definition) return;

      normalizedFilters[definition.key] = definition.type === 'boolean'
        ? { enabled: true }
        : createEmptyFilterValue(definition);
    });
    return normalizedFilters;
  }

  if (!filters || typeof filters !== 'object') return normalizedFilters;

  filterDefinitions.forEach((definition) => {
    const value = filters[definition.key];
    if (definition.type === 'boolean') {
      normalizedFilters[definition.key] = { enabled: Boolean(value?.enabled || value === true) };
      return;
    }

    if (isMultiOptionFilter(definition)) {
      const values = Array.isArray(value) ? value : value?.values;
      normalizedFilters[definition.key] = {
        values: normalizeFilterMultiValues(definition, values),
      };
      return;
    }

    if (definition.type === 'single') {
      normalizedFilters[definition.key] = {
        value: normalizeFilterOptionValue(definition, value?.value || value),
      };
      return;
    }

    normalizedFilters[definition.key] = {
      max: sanitizeFilterNumber(value?.max),
      min: sanitizeFilterNumber(value?.min),
    };
  });

  return normalizedFilters;
};

export const getInvalidRangeFilterKeys = (filters, contactType = 'consumers') => {
  const filterDefinitions = getDataAxleFilterDefinitions(contactType);
  const normalizedFilters = normalizeFindContactFilters(filters, contactType);

  return filterDefinitions
    .filter((definition) => definition.type === 'range')
    .filter((definition) => isRangeFilterValueInvalid(normalizedFilters[definition.key]))
    .map((definition) => definition.key);
};

export const hasInvalidRangeFilters = (filters, contactType = 'consumers') =>
  getInvalidRangeFilterKeys(filters, contactType).length > 0;

export const getEstimateFiltersPayload = (filters, contactType = 'consumers') => {
  const filterDefinitions = getDataAxleFilterDefinitions(contactType);
  const normalizedFilters = normalizeFindContactFilters(filters, contactType);

  return filterDefinitions.reduce((payload, definition) => {
    const value = normalizedFilters[definition.key];
    if (definition.type === 'boolean') {
      if (!value?.enabled) return payload;

      return {
        ...payload,
        [definition.key]: {
          field: definition.field,
          value: true,
        },
      };
    }

    if (isMultiOptionFilter(definition)) {
      const values = Array.isArray(value?.values) ? value.values : [];
      if (!values.length) return payload;
      if (hasAllMultiFilterOptionsSelected(definition, values)) return payload;

      return {
        ...payload,
        [definition.key]: {
          field: definition.field,
          values,
        },
      };
    }

    if (definition.type === 'single') {
      if (!value?.value) return payload;

      return {
        ...payload,
        [definition.key]: {
          field: definition.field,
          value: value.value,
        },
      };
    }

    const min = sanitizeFilterNumber(value?.min);
    const max = sanitizeFilterNumber(value?.max);
    if (min === '' && max === '') return payload;
    if (min !== '' && max !== '' && min > max) return payload;

    return {
      ...payload,
      [definition.key]: {
        field: definition.field,
        ...(min !== '' ? { min } : {}),
        ...(max !== '' ? { max } : {}),
      },
    };
  }, {});
};

export const formatFilterValue = (value, definition) => {
  if (value === '' || value === null || value === undefined) return 'Any';

  const numberValue = Number(value);
  if (!Number.isFinite(numberValue)) return 'Any';
  if (isCurrencyFilter(definition)) return balanceFormatter(numberValue, 0);

  return `${numberValue}`;
};

export const getFilterUnitLabel = (definition) => {
  if (definition.unit === 'currency') return 'USD';
  return definition.suffix || '';
};

export const getFilterDisplayLabel = (definition) => {
  const unitLabel = getFilterUnitLabel(definition);

  return unitLabel ? `${definition.label} (${unitLabel})` : definition.label;
};

export const getFilterPlaceholderText = () => anyFilterOption;

export const getActiveFilterRows = (filters, options = {}) => {
  const { contactType = 'consumers', optionLabelsByKey = {}, showAllOptions = false } = options;
  const filterDefinitions = getDataAxleFilterDefinitions(contactType);
  const normalizedFilters = normalizeFindContactFilters(filters, contactType);

  return filterDefinitions.reduce((rows, definition) => {
    const value = normalizedFilters[definition.key];
    const displayLabel = getFilterDisplayLabel(definition);

    if (definition.type === 'boolean') {
      return value?.enabled
        ? [...rows, { isBoolean: true, key: definition.key, label: displayLabel, value: 'Yes' }]
        : rows;
    }

    if (isMultiOptionFilter(definition)) {
      return value?.values?.length && !hasAllMultiFilterOptionsSelected(definition, value.values)
        ? [
            ...rows,
            {
              key: definition.key,
              label: displayLabel,
              value: getFilterOptionsPreview(
                definition,
                value.values,
                showAllOptions ? Infinity : maxVisibleMultiFilterOptions,
                optionLabelsByKey
              ),
            },
          ]
        : rows;
    }

    if (definition.type === 'single') {
      return value?.value
        ? [
            ...rows,
            {
              key: definition.key,
              label: displayLabel,
              value: getFilterOptionDisplayLabel(definition, value.value, optionLabelsByKey),
            },
          ]
        : rows;
    }

    const min = sanitizeFilterNumber(value?.min);
    const max = sanitizeFilterNumber(value?.max);
    if (min === '' && max === '') return rows;

    return [
      ...rows,
      {
        key: definition.key,
        label: displayLabel,
        value: `${formatFilterValue(min, definition)} - ${formatFilterValue(max, definition)}`,
      },
    ];
  }, []);
};

export const getActiveFilterItems = (filters, options = {}) =>
  getActiveFilterRows(filters, options).map(({ isBoolean, key, label, value }) => ({
    key,
    label: isBoolean ? label : `${label}: ${value}`,
  }));

export const getActiveFilterLabels = (filters, options = 'consumers') => {
  const normalizedOptions = typeof options === 'string' ? { contactType: options } : options;
  return getActiveFilterItems(filters, normalizedOptions).map((item) => item.label);
};
